exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mx-datepicker[data-v-51b86dca]{width:120px!important}", ""]);

// exports
